var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDublicatePage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3269 2H10.0962C9.68303 2 9.28682 2.16712 8.9947 2.46459C8.70258 2.76206 8.53846 3.16552 8.53846 3.58621V16.2759C8.53846 16.6965 8.70258 17.1 8.9947 17.3975C9.28682 17.695 9.68303 17.8621 10.0962 17.8621H19.4423C19.8554 17.8621 20.2516 17.695 20.5438 17.3975C20.8359 17.1 21 16.6965 21 16.2759V6.75862M16.3269 2L21 6.75862M16.3269 2V6.75862H21M16.1538 18.0811V20.4138C16.1538 20.8345 15.9806 21.2379 15.6723 21.5354C15.3639 21.8329 14.9457 22 14.5096 22H4.64423C4.20815 22 3.78994 21.8329 3.48158 21.5354C3.17323 21.2379 3 20.8345 3 20.4138V7.72414C3 7.30345 3.17323 6.89999 3.48158 6.60252C3.78994 6.30505 4.20815 6.13793 4.64423 6.13793H7.93269",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDublicatePage);
export default __webpack_public_path__ + "static/media/dublicatePage.1928e00b120f63ff14a558f5874ca71f.svg";
export { ForwardRef as ReactComponent };